import React, { Component } from 'react';

class LoadingLoader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    componentDidMount() {
        this.setState({ show: this.props.show })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            this.setState({ show: this.props.show })
        }
    }

    render() {
        return (
            <div className={this.state.show ? "block" : "hidden"}>
                <div className="opacity-25 fixed inset-0 bg-black" style={{ zIndex: 1000 }}></div>
                <div className="fixed inset-0 w-full" style={{ zIndex: 1000 }}>
                    <div className="flex justify-center items-center">
                        <div className="h-1 shim-blue w-full"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoadingLoader;